import { render } from "./TextEditor.vue?vue&type=template&id=71de7be8&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=71de7be8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71de7be8"]])

export default __exports__